// generated from 863 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const anniversaryFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("anniversary_filter"),
  // undefined: 857 (99.30%), defined 6 (0.70%)
  blocklisted: z.literal(true).optional(),
  comparison_key: z.enum([
    "20", // 259 (30.01%)
    "6", // 201 (23.29%)
    "16", // 93 (10.78%)
    "1", // 82 (9.50%)
    "15", // 74 (8.57%)
    "3", // 52 (6.03%)
    "4", // 52 (6.03%)
    "5", // 50 (5.79%)
  ]),
  display_name: z.string(),
  // undefined: 334 (38.70%), defined 529 (61.30%)
  raw_value: z
    .union([
      // number samples: 214 (40.45%)
      // avg: 16.84, min: 0, max: 364
      z.int().min(0),
      // string samples: 315 (59.55%)
      // format date: 312 (99.05%)
      z.string(),
    ])
    .optional(),
  value: z.union([
    // number samples: 422 (48.90%)
    // avg: 16.91, min: 0, max: 2020
    z.int().min(0),
    // string samples: 441 (51.10%)
    // format date: 438 (99.32%)
    z.string(),
  ]),
  varies_by_app_group: z.literal(true),
});
